import {externalBaseApi, extractData} from "../../api/axiosConfig";

export const getUsageGridData = productId =>
    externalBaseApi
        .get("/usage/gridData", {
            params: {
                my_product_id: productId
            }
        })
        .then(extractData);

export const addUsage = data =>
    externalBaseApi
        .post("/usage", data)
        .then(extractData);

export const editUsage = (usageId, data) =>
    externalBaseApi
        .put(`/usage/${usageId}`, data)
        .then(extractData);

export const deleteUsage = usageId =>
    externalBaseApi
        .delete(`/usage/${usageId}`)
        .then(extractData);

export const getUsageObligationData = cdpvId =>
    externalBaseApi
        .get("/usage/obligationData", {
            params: {
                my_cdpv_id: cdpvId
            }
        })
        .then(extractData);

export const uploadUsage = usage =>
    externalBaseApi
        .post("/usage/upload", usage)
        .then(extractData);

export const getLanguages = () =>
    externalBaseApi
        .get("/usage/language")
        .then(extractData);

export const getStatuses = () =>
    externalBaseApi
        .get("/usage/status")
        .then(extractData);

export const usageSearch = request =>
    externalBaseApi
        .post("/usage/usageSearch", request)
        .then(extractData);

export const getFileIds = () =>
    externalBaseApi
        .get("/usage/fileId")
        .then(extractData);

export const processUsage = fileId =>
    externalBaseApi
        .get("/usage/process", {
            params: {
                usage_file_id: fileId
            }
        })
        .then(extractData);


//
// import axios from "axios";
//
// const BASE_URL = import.meta.env.VITE_BACKEND_URL;
//
//
// export const getUsageGridData = (my_product_id) =>
//     axios.get(`${BASE_URL}/ExternalData/api/contramatic/usage/gridData`,
//         {
//             headers: {
//                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//             },
//             params: {my_product_id: my_product_id}
//         })
//         // export const executeExpression = (id) =>
//         //     axios.get(`${BASE_URL}/api/contramatic/contractDataPoint/expression/${id}`)
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// export   const addUsage = abcd =>
//     axios.post(`${BASE_URL}/ExternalData/api/contramatic/usage`, abcd, {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         }
//     })
//         .then(function (response) {
//             console.log(response);
//         })
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
// export const editUsage = (selectorUsageId, data) =>
//     axios.put(`${BASE_URL}/ExternalData/api/contramatic/usage/${selectorUsageId}`, data, {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         }
//     })
//         .then(function (response) {
//             console.log(response);
//         })
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// //https://www.javatpoint.com/react-axios-delete-request-example except that it shows the wrong kinds of quotes - not backquotes
// export const deleteUsage = usageId=>
//     axios.delete(`${BASE_URL}/ExternalData/api/contramatic/usage/${usageId}`, {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         }
//     })
//         //https://axios-http.com/docs/handling_errors
//         .then(function (response) {
//             console.log(response);
//         })
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
// export const getUsageObligationData = (my_cdpv_id) =>
//     axios.get(`${BASE_URL}/ExternalData/api/contramatic/usage/obligationData`,
//         {
//             headers: {
//                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//             },
//             params: {my_cdpv_id: my_cdpv_id}
//         })
//         // export const executeExpression = (id) =>
//         //     axios.get(`${BASE_URL}/api/contramatic/contractDataPoint/expression/${id}`)
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
// export   const uploadUsage = (usage) =>
//     axios.post(`${BASE_URL}/ExternalData/api/contramatic/usage/upload`,usage, {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         }
//     })
//         .then(function (response) {
//             console.log(response);
//         })
//         .catch(function (error) {
//             if (error.response) {
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 console.log(error.request);
//             } else {
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// export const getLanguages = () =>
//     axios.get(`${BASE_URL}/ExternalData/api/contramatic/usage/language`, {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         }
//     })
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// export const getStatuses = () =>
//     axios.get(`${BASE_URL}/ExternalData/api/contramatic/usage/status`, {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         }
//     })
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
//
// export const usageSearch = (request) =>
//
//     axios.post(
//         `${BASE_URL}/ExternalData/api/contramatic/usage/usageSearch`,
//         request,
//         // CONFIG
//         {
//             headers: {
//                 Authorization:
//                     'Bearer ' + localStorage.getItem('token'),
//                 'Content-Type': 'application/json'
//             }
//         }
//     )
//
//         .catch(function (error) {
//
//             if (error.response) {
//
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//
//             } else if (error.request) {
//
//                 console.log(error.request);
//
//             } else {
//
//                 console.log('Error', error.message);
//
//             }
//
//             console.log(error.config);
//
//         });
//
//
// export const getFileIds = () =>
//     axios.get(`${BASE_URL}/ExternalData/api/contramatic/usage/fileId`, {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         }
//     })
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
// export const processUsage = (fileId) =>
//     axios.get(`${BASE_URL}/ExternalData/api/contramatic/usage/process`,
//
//         {
//             headers: {
//                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//             },
//             params: {usage_file_id: fileId}
//         })
//         // export const executeExpression = (id) =>
//         //     axios.get(`${BASE_URL}/api/contramatic/contractDataPoint/expression/${id}`)
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });